import axios from 'axios';
import i18n from 'i18next';

// Global axios interceptor to add Accept-Language header to all requests
const setupAxiosInterceptors = () => {
  // Request interceptor to add Accept-Language header
  axios.interceptors.request.use(
    (config) => {
      // Get current language from i18next
      const currentLanguage = i18n.language || 'az';
      
      // Add Accept-Language header if not already present
      if (!config.headers['Accept-Language']) {
        config.headers['Accept-Language'] = currentLanguage;
      }
      
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors; 